import {
  GET_COMPANIES,
  ACCEPT_COMPANY,
  SUBMIT_COMPANY,
  REJECT_COMPANY,
} from "./types";
import axios from "../services/axios";

export function getCompanies() {
  return async function (dispatch) {
    const response = await axios.get("/members/me/companies");
    dispatch({
      type: GET_COMPANIES,
      payload: response.data,
    });
  };
}

export function acceptCompany(accept_info) {
  return async function (dispatch) {
    await axios.post("/members/me/intro", { ...accept_info, type: "ACCEPT" });
    // NOTE: back end just returns OK, so front end needs to update state
    dispatch({
      type: ACCEPT_COMPANY,
      payload: accept_info,
    });
  };
}

export function submitCompany(submit_info) {
  return async function (dispatch) {
    await axios.post("/members/me/intro", { ...submit_info, type: "SUBMIT" });
    // NOTE: back end just returns OK, so front end needs to update state
    dispatch({
      type: SUBMIT_COMPANY,
      payload: submit_info,
    });
  };
}

export function rejectCompany(reject_info) {
  return async function (dispatch) {
    await axios.post("/members/me/intro", { ...reject_info, type: "REJECT" });
    // NOTE: back end just returns OK, so front end needs to update state
    dispatch({
      type: REJECT_COMPANY,
      payload: reject_info,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/introActions.js